import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { UserProfileState } from "../models/store/user-profile-state.model";
import { computed } from '@angular/core';
import { ICvxClaimsPrincipal } from '@cvx-dev/cal-angular';


const initialState: UserProfileState = {
	userProfile: {
		id: '',
		fullName: '',
		email: '',
	imageURL: '',
		roleName: '',
		roleId: null
	},
	token: '',
	graphToken:'',
	isAuthenticated: false,
	isLoading: false,
	errorMessage: ''
};

export const UserProfileStore = signalStore(
	{ providedIn: 'root' },
	withState(initialState),
	withComputed(({ userProfile, token, isAuthenticated, isLoading, errorMessage }) => ({
		profile: computed(() => userProfile() || initialState.userProfile),

		// NO SE PUEDE HACER MAS UN OVERRIDE DE UNA VARIABLE, DE POR SI YA ESTAN PUBLICAS CON ESOS NOMBRES. -------
		// token: computed(() => token),
		// isAuthenticated: computed(() => isAuthenticated),
		// isLoading: computed(() => isLoading),
		// errorMessage: computed(() => errorMessage),
		// --------------------------------------------------------------------------------------------------------
	})),
	withMethods((store) => ({

		StartLoading: () => {
			patchState(store, { isLoading: true, errorMessage: '' });
		},

		EndLoading: () => {
			patchState(store, { isLoading: false });
		},

		EndLoadingWithError: (error: string) => {
			patchState(store, { isLoading: false, errorMessage: error });
		},

		Authenticate: (isAuthenticated: boolean) => {

			patchState(store, { isAuthenticated });
		},

		SetUserProfile: (userProfileCvx: ICvxClaimsPrincipal) => {

			// let currentId= isLoggout? "" : userProfileCvx.objectId || '';
			// let currentFullName= isLoggout? "" : userProfileCvx.name || '';
			// let currentEmail= isLoggout? "" : userProfileCvx.email || '';

			patchState(store, {
				userProfile: {
					...store.userProfile(),
					// id: currentId,
					id: userProfileCvx.objectId || '',
					// fullName: currentFullName,
					fullName: userProfileCvx.name || '',
					// email: currentEmail
					email: userProfileCvx.email || ''
				}
			});

			try {
				if (userProfileCvx?.email) {
					localStorage.setItem('email', userProfileCvx.email);
				} else {
					localStorage.removeItem('email');
				}
			} catch {}
		},

		CleanUserProfile:()=>{
			patchState(store, {
				userProfile: {
					...store.userProfile(),
					// id: currentId,
					id: '',
					fullName: '',
					email:  '',
					roleName: '',
					roleId: null
				}
			});
			try { localStorage.removeItem('roleId'); } catch {}
		},

		SetToken: (token: string) => {
			patchState(store, { token: token });
		},
		SetGraphToken: (graphToken: string) => {
			patchState(store, { graphToken: graphToken });
		},
		SetUserImage: (imageUrl: string) => {

			patchState(store, {
				userProfile: {
					...store.userProfile(),
					imageURL: imageUrl || ''
				}
			});

		},

		SetUserRoleName: (roleName: string) => {
			patchState(store, {
				userProfile: {
					...store.userProfile(),
					roleName: roleName || ''
				}
			});
		},

		SetUserRoleId: (roleId: number | null) => {
			patchState(store, {
				userProfile: {
					...store.userProfile(),
					roleId: roleId ?? null
				}
			});
			try {
				if (roleId !== null && roleId !== undefined) {
					localStorage.setItem('roleId', String(roleId));
				} else {
					localStorage.removeItem('roleId');
				}
			} catch {}
		},

		SetUserEmail: (email: string) => {
			patchState(store, {
				userProfile: {
					...store.userProfile(),
					email: email || ''
				}
			});
			try {
				if (email) {
					localStorage.setItem('email', email);
				} else {
					localStorage.removeItem('email');
				}
			} catch {}
		},

	}))
);
